/**
 * AdminPitch — Live capability sheet you can flex at happy hour.
 */
import { useEffect, useState } from "react";
import { AdminShell } from "@/components/Layout";
import { api } from "@/lib/api";
import { ChartLineUp, FilePdf, Camera, ShieldCheck, Users, Buildings, Sparkle, ImageSquare } from "@phosphor-icons/react";

const CARDS = [
  { k: "jobs",                    label: "Work Orders Managed",   icon: Buildings, tone: "from-slate-700 to-slate-900" },
  { k: "properties",              label: "Properties Under Care", icon: Buildings, tone: "from-cyan-700 to-cyan-900" },
  { k: "inspections_done",        label: "Inspections Completed", icon: ShieldCheck, tone: "from-emerald-700 to-emerald-900" },
  { k: "quotes_finalized",        label: "Quotes Sent",           icon: FilePdf, tone: "from-blue-700 to-blue-900" },
  { k: "quotes_accepted",         label: "Quotes Accepted",       icon: FilePdf, tone: "from-blue-800 to-indigo-800" },
  { k: "change_orders",           label: "Change Orders",         icon: Sparkle, tone: "from-indigo-700 to-violet-900" },
  { k: "change_orders_accepted",  label: "COs Accepted",          icon: Sparkle, tone: "from-violet-700 to-fuchsia-900" },
  { k: "photo_albums_shared",     label: "Progress Albums Shared",icon: ImageSquare, tone: "from-cyan-600 to-teal-800" },
  { k: "esign_sent",              label: "E-Sign Requests",       icon: FilePdf, tone: "from-orange-700 to-red-800", altKey: "esign_requests" },
  { k: "esign_signed",            label: "Documents Signed",      icon: FilePdf, tone: "from-emerald-700 to-green-900" },
  { k: "sub_contractors",         label: "Sub-Contractors",       icon: Users, tone: "from-amber-700 to-orange-900" },
  { k: "workers",                 label: "Field Techs",           icon: Users, tone: "from-slate-700 to-slate-900" },
];

export default function AdminPitch() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/pitch/stats").then(r => setStats(r.data)).catch(() => {}); }, []);
  const c = stats?.counts || {};

  return (
    <AdminShell>
      <div className="max-w-5xl mx-auto p-4 space-y-4">
        <div className="flex items-center gap-3">
          <div className="p-2 rounded-xl bg-gradient-to-br from-emerald-700 to-teal-900 text-white">
            <ChartLineUp weight="fill" size={26}/>
          </div>
          <div>
            <h1 className="text-2xl font-black text-slate-900">Pitch Radar</h1>
            <p className="text-sm text-slate-500">Live capability sheet — real numbers pulled from your company. Screenshot this for owners &amp; competitors.</p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2">
          {CARDS.map(card => {
            const Icon = card.icon;
            const v = c[card.k] ?? c[card.altKey || ""] ?? 0;
            return (
              <div key={card.k} className={`rounded-xl bg-gradient-to-br ${card.tone} text-white p-3 shadow-md`}>
                <Icon weight="fill" size={16} className="opacity-80"/>
                <div className="text-3xl font-black mt-1">{v.toLocaleString()}</div>
                <div className="text-[10px] font-black uppercase tracking-widest opacity-80 mt-0.5">{card.label}</div>
              </div>
            );
          })}
        </div>

        {stats?.generated_at && (
          <div className="text-[10px] text-slate-400 text-center">
            Generated {new Date(stats.generated_at).toLocaleString()} · Numbers auto-refresh as you work
          </div>
        )}
      </div>
    </AdminShell>
  );
}
